export default __webpack_public_path__ + "img/9775515195d521c4d483d8a1d763ef07.jpg";